import { render, staticRenderFns } from "./table-tabs-nav.vue?vue&type=template&id=864f92f8"
import script from "./table-tabs-nav.vue?vue&type=script&lang=js"
export * from "./table-tabs-nav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_vue-template_ptp2uvm53q35aphlzqn6rhtzgm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports